import { render, staticRenderFns } from "./SectionHomepage.vue?vue&type=template&id=2b7dd3f2&"
import script from "./SectionHomepage.vue?vue&type=script&lang=js&"
export * from "./SectionHomepage.vue?vue&type=script&lang=js&"
import style0 from "./SectionHomepage.vue?vue&type=style&index=0&id=2b7dd3f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports